// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const VoicemailConfigService = {
    // Create the voicemail box
    CreateVoicemailBox(fn, req) {
        return fn(`/phone/voicemail-config/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateVoicemailBox(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v1/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListVoicemailBoxes(fn, req) {
        return fn(`/phone/voicemail-config/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListExtensions(fn, req) {
        return fn(`/phone/voicemail-config/v1/extensions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // This endpoint is only used for updating voicemail box in WAM
    MailboxUpdate(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/voicemail-config/v1/mailbox/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
